import React, { useContext } from 'react';
import { message } from 'antd';
import DeleteConfirmationModal from 'src/components/common/DeleteConfirmationModal';
import { OperationType } from './types/SelectedOperation';
import ProductAssociationLookup from './types/ProductAssociationLookup';
import { ProductAlertsContext } from './ProductAlertsProvider';
import { FormCreateSegment } from './FormSegment/FormCreateSegment';
import { FormEditSegment } from './FormSegment/FormEditSegment';
import { FormCloneSegment } from './FormSegment/FormCloneSegment';
import { EditProductAssociationModal } from './EditProductAssociationModal';
import { addProductAssociationLookup } from './api/productAssociation.api';

export const SelectedOperationActions: React.FC = () => {
  const { selectedOperation, setSelectedOperation, reloadSegmentList } = useContext(ProductAlertsContext);
  const closeModal = () => setSelectedOperation(null);

  const handleProductAssociationSubmit = async (data: ProductAssociationLookup) => {
    try {
      await addProductAssociationLookup(data);
      message.success('Product Association Updated');
    } catch {
      message.error('Products Association haven`t been configured!');
    }
    closeModal();
    return null;
  };

  switch (selectedOperation?.type) {
    case OperationType.CreateSegment:
      return <FormCreateSegment closeModal={closeModal} onComplete={reloadSegmentList} />;

    case OperationType.EditSegment:
      return (
        <FormEditSegment
          productSegment={selectedOperation.productSegment}
          closeModal={closeModal}
          onComplete={reloadSegmentList}
        />
      );

    case OperationType.CloneSegment:
      return (
        <FormCloneSegment
          productSegment={selectedOperation.productSegment}
          closeModal={closeModal}
          onComplete={reloadSegmentList}
        />
      );

    case OperationType.DeleteSegment:
      return (
        <DeleteConfirmationModal
          visible={true}
          itemName={selectedOperation.productSegment.productSegmentName}
          onClose={closeModal}
          onConfirm={() => {
            selectedOperation.operation();
            closeModal();
          }}
        />
      );

    case OperationType.ConfigureAssociatedProducts:
      return (
        <EditProductAssociationModal
          isOpenModal={true}
          hideModal={closeModal}
          productName={selectedOperation.productSegment.productSegmentName}
          productSegmentId={selectedOperation.productSegment.productSegmentId}
          associatedProductCount={selectedOperation.productSegment.associatedProductCount}
          onSubmit={handleProductAssociationSubmit}
        />
      );
  }

  return null;
};
